import { Fieldset } from '@antimatterhq/ui/components/fieldset';
import { DatasourceReviewValue } from '../value/DatasourceReviewValue';
import { Datasource_UnreferencedColumns } from '@/types/api';
import { DatasourceUpgradeFieldUtilsDiff } from '@/lib/datasource/upgrade/datasourceUpgrade.types';

export const UnreferencedColumnsReview = ({
  unreferencedColumns = {},
  upgradeState,
}: {
  unreferencedColumns?: Datasource_UnreferencedColumns | null;
  upgradeState?: DatasourceUpgradeFieldUtilsDiff | null;
}) => {
  return (
    <div>
      <Fieldset.Field>
        <Fieldset.Label>Unreferenced fields</Fieldset.Label>
      </Fieldset.Field>
      <Fieldset.List>
        <Fieldset.Field>
          <Fieldset.Label>Preserve unreferenced columns:</Fieldset.Label>
          <Fieldset.Value>
            <DatasourceReviewValue
              status={upgradeState?.unreferencedColumns?.preserve?.status}
            >
              {unreferencedColumns?.preserve ? 'yes' : 'no'}
            </DatasourceReviewValue>
          </Fieldset.Value>
        </Fieldset.Field>
        {unreferencedColumns?.preserve && (
          <>
            <Fieldset.Field>
              <Fieldset.Label>
                Embed unreferenced columns into a new column:
              </Fieldset.Label>
              <Fieldset.Value>
                {unreferencedColumns?.embedColumn ? 'yes' : 'no'}
              </Fieldset.Value>
            </Fieldset.Field>
            {!unreferencedColumns?.embedColumn && (
              <Fieldset.Field>
                <Fieldset.Label>
                  Prefix for colliding column names:
                </Fieldset.Label>
                <Fieldset.Value>
                  <DatasourceReviewValue
                    status={
                      upgradeState?.unreferencedColumns?.duplicatePrefix?.status
                    }
                  >
                    {unreferencedColumns?.duplicatePrefix || (
                      <span className="italic">[default]</span>
                    )}
                  </DatasourceReviewValue>
                </Fieldset.Value>
              </Fieldset.Field>
            )}
            {unreferencedColumns?.embedColumn && (
              <Fieldset.Field>
                <Fieldset.Label>Destination column:</Fieldset.Label>
                <Fieldset.Value>
                  <DatasourceReviewValue
                    status={
                      upgradeState?.unreferencedColumns?.embedColumn?.status
                    }
                  >
                    {unreferencedColumns?.embedColumn}
                  </DatasourceReviewValue>
                </Fieldset.Value>
              </Fieldset.Field>
            )}
            <Fieldset.Field>
              <Fieldset.Label>Omit columns:</Fieldset.Label>
              <Fieldset.Value>
                <DatasourceReviewValue
                  status={
                    upgradeState?.unreferencedColumns?.omitColumns?.status
                  }
                >
                  {unreferencedColumns?.omitColumns?.length ? (
                    unreferencedColumns?.omitColumns?.join(', ')
                  ) : (
                    <span className="italic">[none]</span>
                  )}
                </DatasourceReviewValue>
              </Fieldset.Value>
            </Fieldset.Field>
          </>
        )}
      </Fieldset.List>
    </div>
  );
};
